/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Status_MatchingInputs */

const en_import_status_matching = /** @type {(inputs: Import_Status_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching ingredients…`)
};

const de_import_status_matching = /** @type {(inputs: Import_Status_MatchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten werden zugeordnet…`)
};

/**
* | output |
* | --- |
* | "Matching ingredients…" |
*
* @param {Import_Status_MatchingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_status_matching = /** @type {((inputs?: Import_Status_MatchingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Status_MatchingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_status_matching(inputs)
	return en_import_status_matching(inputs)
});